import React, { Component } from 'react';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { SYSTEM_VERSION } from '../../../../config/consts';

import { Content, ContentHeader } from '../../../../common/components/layout';

import { getList } from './adminDashboardActions';
import Loading from '../../../../common/components/ui/loading/loading';
import ValueBox from '../../../../common/components/widget/value-box/value-box';

class AdminDashboard extends Component {
	constructor(props) {
		super(props);
		this.props.getList();
	}

	render() {
		if (this.props.loading) {
			return (
				<Loading
					isVisible={this.props.loading}
					overlay={false}
                />
			)
		}
		return (
			<div>
				<ContentHeader title='Administração' small={`Versão ${SYSTEM_VERSION}`} />
				<Content>
					<ValueBox
						cols="12 6 4 3"
						color="blue"
						icon="users"
						text="Usuários"
						value={this.props.infos.users}
						iconColor="white" 
					/>
					<ValueBox
						cols="12 6 4 3"
						color="blue"
						icon="charts"
						text="Mapas natais"
						value={this.props.infos.charts}
						iconColor="white" 
					/>
					<ValueBox
						cols="12 6 4 3"
						color="blue"
						icon="city"
						text="Cidades"
						value={this.props.infos.cities}
						iconColor="white" 
					/>
					<ValueBox
						cols="12 6 4 3"
						color="blue"
						icon="state"
						text="Estados"
						value={this.props.infos.states}
						iconColor="white" 
					/>
					<ValueBox
						cols="12 6 4 3"
						color="blue"
						icon="country"
						text="Países"
						value={this.props.infos.countries}
						iconColor="white" 
					/>
				</Content>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		infos: state.dashboard_admin.list.content,
        pagination: state.dashboard_admin.list.pagination,
        loading: state.dashboard_admin.loading
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ getList }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);